
import { makeRequest } from 'utils/requestLogger';

export default (live_discussion_id, job_id) =>
    makeRequest(
        'get',
        `/api/live_discussions/${live_discussion_id}/grade-classroom-students/job/${job_id}`
    );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/gradeGoogleClassroomStudentsJobStatus.js